import React, { useEffect } from 'react';
import endpoints from 'constants/endpoints';
import useApi from 'hooks/useApi';
import useFormHandler from 'hooks/useFormHandler';
import { Button, DynamicForm } from 'components';
import { Props } from 'types/modals';
import Base from '../../base';
import schema from './schema';

const EditionAccountModal = ({ closing, onClose, params }: Props) => {
  const formHandler = useFormHandler(schema);
  const api = useApi();

  useEffect(() => {
    api.fetchData(endpoints.GET_ACCOUNT.get(params));
  }, []);

  useEffect(() => {
    if (api.loaded) {
      const r = api.response.data;
      const data = {
        name: r.name,
        abbreviation: r.abbreviation,
        backgroundCheck: r.background_check,
        alcoholInstructionsUrl: r.alcohol_instructions_url
      };
      formHandler.setFullForm(data);
    }
  }, [api.response, api.loaded]);

  return (
    <Base
      header="Edit account"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={
        <Button
          text="Save changes"
          disabled={!formHandler.valid || formHandler.isSubmitting}
          onClick={() => {
            formHandler.setIsSubmitting(true);
            onClose(formHandler.data);
          }}
        />
      }
    >
      <DynamicForm handler={formHandler} />
    </Base>
  );
};

export default EditionAccountModal;
